import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface SegmentedOption {
  value: string;
  label: string;
}

/** Pill-style segmented status/filter control (mockup `.avseg`). */
@Component({
  selector: 'app-segmented',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './segmented.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentedComponent {
  @Input() options: SegmentedOption[] = [];
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  select(v: string) {
    if (v === this.value) return;
    this.value = v;
    this.valueChange.emit(v);
  }
}
